<template>
  <div class="main main-really-raised w-50 ml-auto mr-auto">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card card-signup no-shadow">
            <br />

            <div v-if="response_info.length > 0">
              <div
                class="card-header card-header-primary negative blue-grad w-50"
              >
                <h4>
                  {{ $t("message.find_partner.corporate_news_search")
                  }}<span v-if="doc_additional && doc_additional.request"
                    >: {{ doc_additional.request }}</span
                  >
                </h4>
              </div>
              <br />
              <!-- <b-table :fields="corporate_search_list_fields" :items="response_info" :fixed="true">

                                </b-table> -->
            </div>
            <div v-else>
              {{ $t("message.find_partner.no_results") }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
export default {
  props: ["user_id", "doc_id", "doc", "goods", "doc_additional"],
  data() {
    return {
      current_tab: 0,
      response_info: {},
      service_info: {},
      service_info_objects: {},
      keyWord: "",
      searchComplete: false,
      corporate_search_list_fields: [
        {
          key: "Id",
          label: this.$t("message.find_partner.corporate_news_search_Id"),
        },
        {
          key: "NewsId",
          label: this.$t("message.find_partner.corporate_news_search_NewsId"),
        },
        {
          key: "Source",
          label: this.$t("message.find_partner.corporate_news_search_Source"),
        },
        {
          key: "Title",
          label: this.$t("message.find_partner.corporate_news_search_Title"),
        },
        {
          key: "Url",
          label: this.$t("message.find_partner.corporate_news_search_Url"),
        },
        {
          key: "PublishTime",
          label: this.$t(
            "message.find_partner.corporate_news_search_PublishTime",
          ),
        },
        {
          key: "EmotionType",
          label: this.$t(
            "message.find_partner.corporate_news_search_EmotionType",
          ),
        },
        {
          key: "Category",
          label: this.$t("message.find_partner.corporate_news_search_Category"),
        },
        {
          key: "NewsTags",
          label: this.$t("message.find_partner.corporate_news_search_NewsTags"),
        },
        {
          key: "Content",
          label: this.$t("message.find_partner.corporate_news_search_Content"),
        },
      ],
    };
  },
  mounted() {
    this.response_info = this.doc;
    setTimeout(() => {
      this.$root.$emit("print-pdf", {
        signature: "",
        type: "corporate_news_service-cn",
      });
    }, 2000);
  },
  computed: {},
  methods: {
    momentum(d) {
      return moment(d).format("D.MM.Y");
    },
    // searchCompanyCourtInfo() {
    //     axios.get(window.base+'/admin/GetBillingServiceInfo?code=701')
    // 		.then(response=>{
    // 			this.$bvModal.msgBoxConfirm(this.$t('message.find_partner.cn_company_info_check_alert') + ' ' + response.data.billing_service_price + ' ' + response.data.billing_service_cur, {
    // 				title: this.$t('message.confirm'),
    // 				size: 'sm',
    // 				buttonSize: 'sm',
    // 				okVariant: 'danger',
    // 				okTitle: this.$t('message.yes'),
    // 				cancelTitle: this.$t('message.no'),
    // 				footerClass: 'p-2',
    // 				hideHeaderClose: false,
    // 				centered: true
    // 				}).then(value => {
    // 					if(value){
    // 						axios.get(window.base + '/library/openAPINewsMock?keyWord=' + this.keyWord).then(response => {
    //                         this.searchComplete = true;
    //                         this.response_info = response.data.Result;
    //                         this.service_info_objects = this.service_info.filter(item => typeof item[1] === 'object' && item[1] !== null && !_.isArray(item[1]));

    //                     })
    // 					}
    // 				})
    // 		})

    // }
  },
};
</script>
